export default {
  personal_info: {
    already_signed_up:
      'This operation is not allowed since user is already signed up.',
    already_have_email:
      'User already exists, please log in to the portal or use a different email address',
    oldpassword_mismatch: 'Your old password is not correct!',
  },
}
